import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import SaveCommand from './savecommand';

const SAVE = 'save';

export default class SaveEditing extends Plugin {
  init() {
    const editor = this.editor;

    // Create save command.
    editor.commands.add( SAVE, new SaveCommand( editor, SAVE ) );

    editor.keystrokes.set( 'CTRL+S', SAVE );
  }
}
